var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSteeringWheel = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Steering Wheel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Steering-Wheel",
    transform: "translate(14.000000, 14.000000) rotate(-90.000000) translate(-14.000000, -14.000000) translate(2.000000, 2.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 4,
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7058824,12.7058824 L3.52941176,20.4705882",
    id: "Line",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7058824,11.2941176 L3.52941176,4.94117647",
    id: "Line-2",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4117647,12 L23.2941176,12",
    id: "Line-3",
    strokeWidth: 3,
    strokeLinecap: "square"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSteeringWheel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/steering-wheel.52549bb8f44ade0bd8b7256ca53e7c2f.svg";